module.exports = __webpack_public_path__ + "static/media/wow2.9ce632aa.gif";